import { ExamplePanel } from "../helpers";
import { FieldExample } from "./field";
export const Form = () => {
    return ExamplePanel({
        title: 'Form',
        tabs: [{
                title: 'Field',
                name: 'field',
                link: '/#/form/field',
                example: FieldExample
            }]
    });
};
